<app-actionbar-layout
  [title]="workshop?.title ?? ''"
  [buttonsTemplate]="buttonsTemplate"
  [contentTemplate]="contentTemplate"
  [defaultBackRoute]="defaultBackRoute"
>
</app-actionbar-layout>

<ng-template #buttonsTemplate>
  <p-button
    iconPos="right!"
    icon="pi pi-user-plus"
    [disabled]="!form?.valid"
    [label]="isPreRegister ? 'پیش ثبت‌نام' : registerLabel"
    (onClick)="onRegister()"
  >
  </p-button>
  @if (!isPreRegister) {
    <a target="_blank" [href]="workshop.googleCalendarNewEventUrl">
      <p-button
        outlined
        iconPos="right!"
        icon="pi pi-calendar"
        label="افزودن به تقویم"
      ></p-button>
    </a>
  }
</ng-template>

<ng-template #contentTemplate>
  @if (workshop) {
    <div class="m-3!">
      <section
        class="bg-white bg-opacity-50 rounded d-flex justify-content-around p-2 p-lg-3"
      >
        <div class="d-flex align-items-center justify-content-center gap-2">
          <ng-icon
            name="lucideLayers"
            class="fs-5 text-muted opacity-50"
          ></ng-icon>
          <span class="text-muted">{{ workshop.holdingTypeTitle }}</span>
        </div>
        <div></div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <ng-icon
            name="lucideClock"
            class="fs-5 text-muted opacity-50"
          ></ng-icon>
          <span class="text-muted">{{ workshop.holdingDateJalali }}</span>
        </div>
      </section>
      <section class="d-flex justify-content-center">
        @if (workshop.coverImage) {
          <afra-image
            imgClass="cover-img"
            [fileId]="workshop.coverImage"
            alt="workshop cover image"
          ></afra-image>
        } @else {
          <img
            class="cover-img"
            src="/assets/images/video_cover.png"
            alt="workshop cover image"
          />
        }
      </section>
      <section>
        <div
          class="text-justify"
          [innerHTML]="workshop.description | safeHtml"
        ></div>
      </section>
      @if (workshop.prerequisites?.length) {
        <section class="mt-8!">
          <h6>پیش‌نیاز ها</h6>
          <div class="bg-white rounded shadow-sm p-4">
            @for (pre of workshop.prerequisites; track $index) {
              <div class="flex items-center mb-2 gap-2">
                <i class="pi pi-circle-fill text-[8px]! text-surface-700"></i>
                @switch (pre.type) {
                  @case (1) {
                    {{ pre.displayTitle }}
                  }
                  @case (2) {
                    <a
                      [routerLink]="[
                        '/e-workshops',
                        pre.workshopId,
                        pre.videoId,
                      ]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ pre.displayTitle }}
                    </a>
                  }
                  @case (3) {
                    <a
                      [href]="pre.link"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="openInNewTab(pre.link, $event)"
                    >
                      {{ pre.displayTitle }}
                    </a>
                  }
                }
              </div>
            }
          </div>
          <div class="my-5"></div>
        </section>
      }
      <form [formGroup]="form">
        @if (workshop) {
          <div>
            <h5>{{ "فرم ثبت‌نام" }}</h5>
            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <label class="form-label">{{ attendanceTypeLabel }}</label>
                <p-select
                  [options]="workshop?.holdingType || []"
                  optionLabel="title"
                  optionValue="id"
                  formControlName="attendanceTypeId"
                  class="w-100"
                ></p-select>
              </div>
              <div class="col-12 col-md-6 mt-4 mt-md-0">
                <label class="form-label">{{ informWayLabel }}</label>
                <p-select
                  [options]="informWays"
                  optionLabel="title"
                  optionValue="id"
                  formControlName="informWayId"
                  class="w-100"
                ></p-select>
              </div>
              @if (workshop?.hasQuestionBox) {
                <div class="col-12 mt-4">
                  <label class="form-label"
                    >کاربر گرامی؛ برای برگزاری هرچه بهتر کارگاه و ارائه پاسخ
                    مناسب، لطفاً پرسش‌های خود را از طریق قسمت زیر ارسال کنید تا
                    در کارگاه به آن‌ها پاسخ دهیم.</label
                  >
                  <textarea
                    pTextarea
                    formControlName="questions"
                    [autoResize]="true"
                    class="w-100"
                    style="height: 130px"
                  ></textarea>
                </div>
              }
              @if (workshop?.showMotivationLetter) {
                <div class="col-12 mt-4">
                  <label class="form-label">انگیزه‌نامه</label>
                  <textarea
                    pTextarea
                    formControlName="motivation_letter"
                    [autoResize]="true"
                    class="w-100"
                    style="height: 130px"
                  ></textarea>
                </div>
              }
            </div>
            <div class="mt-3 lh-lg d-flex align-items-center">
              <p-checkbox
                [binary]="true"
                formControlName="confirmed"
              ></p-checkbox>
              <span class="ms-2">{{ registerPromptLabel }}</span>
            </div>
          </div>
        }
        <div class="mt-3 text-primary-500">
          {{
            workshop.remaining_capacity > 0 ? workshop.remaining_capacity : 0
          }}
          نفر ظرفیت مانده.
        </div>
      </form>
      <div class="my-5"></div>
      <section class="mt-3">
        <h6>درباره استاد</h6>
        @for (t of workshop.teachers; track $index) {
          <div class="p-3 p-lg-4 m-2">
            <app-teacher-info-card
              [teacherId]="t.id"
              [name]="t.name"
              [avatar]="t.avatar"
              [position]="t.position"
              [workshopsCount]="t.workshopsCount"
              [bio]="t.bio"
              [linkName]="true"
            ></app-teacher-info-card>
          </div>
        }
      </section>
    </div>
  }
</ng-template>
